import { render } from "./StoreDefaultsSection.vue?vue&type=template&id=060eee70&scoped=true"
import script from "./StoreDefaultsSection.vue?vue&type=script&lang=js"
export * from "./StoreDefaultsSection.vue?vue&type=script&lang=js"

import "./StoreDefaultsSection.vue?vue&type=style&index=0&id=060eee70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060eee70"]])

export default __exports__